// src/components/guide/TriggerCard.jsx
import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useGuide } from '../../contexts/GuideContext';

export default function TriggerCard({ result }) {
  const guide = useGuide();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const run = async fn => { setBusy(true); setError(''); try { await fn(result); } catch (e) { setError(e.message || 'That did not work. Try again.'); } finally { setBusy(false); } };
  const { copy, trigger } = result;
  return <section className={`guide-card guide-card-${trigger.surface}`} aria-label="Guide suggestion" data-guide-ui>
    <button type="button" className="guide-card-close" aria-label="Dismiss suggestion" onClick={() => guide.dismiss(result)}><X size={14}/></button>
    <strong>{copy.title}</strong>
    <p>{copy.body}</p>
    {error && <p className="v2-error" role="alert">{error}</p>}
    <div className="guide-card-actions">
      <button type="button" className="v2-button" disabled={busy} onClick={() => run(guide.runPrimary)}>{busy ? 'Working…' : copy.primary.label}</button>
      {copy.secondary && <button type="button" className="v2-button secondary" disabled={busy} onClick={() => run(guide.runSecondary)}>{copy.secondary.label}</button>}
    </div>
  </section>;
}
